import { Component, ViewChild, inject, OnInit, OnDestroy } from '@angular/core';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { UserActionDialogConfig } from './user-action-dialog-config.model';
import { UserActionDialogModalService } from './user-action-dialog-modal.service';

@Component({
  selector: 'app-user-action-dialog',
  templateUrl: './user-action-dialog.component.html',
  styleUrls: ['./user-action-dialog.component.scss'],
  standalone: false
})
export class UserActionDialogComponent implements OnInit, OnDestroy {
  private readonly userActionDialogModalService = inject(UserActionDialogModalService);
  private readonly subscriptions: any[] = [];
  userActionDialogConfig: UserActionDialogConfig;
  @ViewChild('modalRef') modalComponent: ModalComponent;

  ngOnInit(): void {
    const sub = this.userActionDialogModalService.modalState$.subscribe((data) => {
      if (!data) return;
      if (data?.config) {
          this.userActionDialogConfig = data?.config;
      }
      if (data?.isOpen) {
        this.open();
      } else {
        this.close();
      }
    });
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    for (const s of this.subscriptions) {
      s.unsubscribe();
    }
  }

  public open(): void {
    this.modalComponent?.open();
  }

  public close(): void {
    this.modalComponent?.close();
  }
}
